const $overlay = $('#pre-click-overlay');

const mapPreClickOverlay = {
  initialize() {
    $('body').on('click', '#pre-click-overlay', () => {
      this.hideOverlay();
    });
  },
  hideOverlay() {
    $overlay.hide();
  },
};

export default mapPreClickOverlay;
